import React from 'react';
import qs from 'qs';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getActiveUser } from 'Store/reducers';

import ContentFrame from 'Components/ContentFrame';
import SectionHeader from 'Components/SectionHeader';
import ForgotPasswordForm from 'Containers/ForgotPasswordForm';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import { withRouter } from 'react-router';
import { ROUTES } from 'Settings/route-strings';

class ForgotPassword extends React.Component {
  componentDidUpdate() {
    const { activeUser, location, history } = this.props;
    // Check to see if we have an active user and send them on their way.
    if (activeUser) {
      const { redirect } = qs.parse(location.search, {
        ignoreQueryPrefix: true,
      });
      const next = redirect || ROUTES.EXPLORE;
      history.replace(next);
    }
  }

  render() {
    return (
      <main className="Page__content">
        <ContentFrame pageType="transactional" size="small">
          <SectionHeader
            title={
              <ConnectedFormattedMessage id="forgot_password_page.title" />
            }
            description={
              <p className="SectionHeader__description">
                <ConnectedFormattedMessage id="forgot_password_page.description" />
              </p>
            }
          />
          <ForgotPasswordForm />
        </ContentFrame>
      </main>
    );
  }
}

ForgotPassword.propTypes = {
  activeUser: PropTypes.object,
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }),
};

const mapStateToProps = state => {
  return {
    activeUser: getActiveUser(state),
  };
};

export default withRouter(connect(mapStateToProps, {})(ForgotPassword));
